import React from 'react';
// import Map from './Map';
import DiningPackages from './DiningPackages';
import LodgeRental from './LodgeRental';
import FullWidthSection from './FullWidthSection'
import groupsStyles from './groups.module.sass';

export default props => {

  const { acf, onScrolledOverDifferentColor } = props

  return (
    <div className={groupsStyles.groups}>
      <div className={groupsStyles.content}>
        { acf.diningpackages && <DiningPackages diningpackages={acf.diningpackages} /> }
        { 
          acf.lodgerental.show && (
          <FullWidthSection onScrolledOverDifferentColor={onScrolledOverDifferentColor}>
            <LodgeRental lodgerental={acf.lodgerental} />
          </FullWidthSection>
          )
        }
      </div>
    </div>
  )

};